import { CustomerTrackingData } from '@jbhi-fi/components/src/Tracking';

export const hashValue = (value): string => {
  return value && window.sha256(value);
};

export const getHashedCustomerId = (): string => {
  return hashValue(window.Jbhifi?.shopifyCustomerId);
};

export const getHashedCustomerEmail = (): string => {
  return hashValue(window.Jbhifi?.customerEmail?.toLowerCase());
};

export const getCustomerTrackingData = (): CustomerTrackingData => {
  const address = window.Jbhifi?.addresses?.find(address => address.default);

  return {
    userId: getHashedCustomerId(),
    isLoggedIn: window.Jbhifi?.customerDetails?.isLoggedIn,
    hashedEmail: getHashedCustomerEmail(),
    hashedPhone: hashValue(address?.phone),
    postcode: address?.zip,
    state: address?.provinceCode,
  };
};
